import * as BookNow from './BookNow';

window.displayBookNow = BookNow.display;
